import { Box, Heading, Divider } from '@hover/blueprint';
import React from 'react';
import FirstTeamValue from './FirstTeamValue';
import SecondTeamValue from './SecondTeamValue';
import ThirdTeamValue from './ThirdTeamValue';

interface Props {
  selectedValue: string;
  setSelectedValue: (value: string) => void;
}

const TeamValuesSectionDesktop: React.FC<Props> = ({
  selectedValue,
  setSelectedValue,
}) => (
  <Box flexDir="column" display={{ base: 'none', desktop: 'flex' }}>
    <Divider
      color="green.200"
      borderWidth="1px"
      mb={800}
      display={{ base: 'none', desktop: 'block' }}
    />
    <Box
      pt={200}
      flexDir="row"
      alignItems="flex-start"
      justifyContent="space-between"
    >
      <Box flexDir="column">
        <Heading
          onClick={() => setSelectedValue('think')}
          size={900}
          color={selectedValue === 'think' ? 'green.500' : 'green.100'}
          cursor="pointer"
        >
          Think.
        </Heading>
        <Divider color="green.200" my={400} borderWidth="1px" mb={700} />
        <Heading
          onClick={() => setSelectedValue('do')}
          mt={200}
          size={900}
          color={selectedValue === 'do' ? 'green.500' : 'green.100'}
          cursor="pointer"
        >
          Do.
        </Heading>
        <Divider color="green.200" my={400} borderWidth="1px" mb={700} />
        <Heading
          onClick={() => setSelectedValue('serve')}
          mt={200}
          size={900}
          color={selectedValue === 'serve' ? 'green.500' : 'green.100'}
          cursor="pointer"
        >
          Serve.
        </Heading>
      </Box>
      <FirstTeamValue visible={selectedValue === 'think'} />
      <SecondTeamValue visible={selectedValue === 'do'} />
      <ThirdTeamValue visible={selectedValue === 'serve'} />
    </Box>
    <Divider
      color="green.200"
      borderWidth="1px"
      mb={900}
      display={{ base: 'none', desktop: 'block' }}
    />
  </Box>
);

export default TeamValuesSectionDesktop;
